var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"neutral50",attrs:{"id":"landing-page"}},[_c('header-landing-new'),_c('v-main',[_c('router-view')],1),_c('footer-landing-new')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }